import React from 'react';
import { TypeOfEntityType } from 'models/ComunicationHub';
import { ValidationErrors } from 'constants/validations';
import { Form, Input, Select } from 'components';
import { useBrandSelectListQuery, useClientSelectListQuery, useSupplierSelectListQuery } from 'api';

interface IRelationEntity {
  entity: TypeOfEntityType | '';
  relations: Record<string, any>[];
  entityId?: string;
  mode?: 'add' | 'edit';
}

export const RelationEntity = (props: IRelationEntity) => {
  const { data: brandList = [] } = useBrandSelectListQuery();
  const { data: supplierList = [] } = useSupplierSelectListQuery();
  const { data: clientList = [] } = useClientSelectListQuery();
  const { entity = '', relations, mode = 'add', entityId } = props;

  switch (entity) {
    case '':
      return null;
    case 'BRAND':
      return (
        <Form.Item
          name={mode === 'add' ? 'relationEntity' : 'editRelationEntity'}
          label={'Entity*'}
          rules={[{ required: true, message: ValidationErrors.required('Entity') }]}
        >
          <Select
            options={brandList.map((i: { value: string; label: string }) => ({
              ...i,
              disabled: !(entityId && entityId === i.value) && relations.some((r) => r.relationEntity === i.value),
            }))}
            size={'large'}
          />
        </Form.Item>
      );
    case 'SUPPLIER':
      return (
        <Form.Item
          name={mode === 'add' ? 'relationEntity' : 'editRelationEntity'}
          label={'Entity*'}
          rules={[{ required: true, message: ValidationErrors.required('Entity') }]}
        >
          <Select
            options={supplierList.map((i: { value: string; label: string }) => ({
              ...i,
              disabled: !(entityId && entityId === i.value) && relations.some((r) => r.relationEntity === i.value),
            }))}
            size={'large'}
          />
        </Form.Item>
      );
    case 'CLIENT':
      return (
        <Form.Item
          name={mode === 'add' ? 'relationEntity' : 'editRelationEntity'}
          label={'Entity*'}
          rules={[{ required: true, message: ValidationErrors.required('Entity') }]}
        >
          <Select
            options={clientList.map((i: { value: string; label: string }) => ({
              ...i,
              disabled: !(entityId && entityId === i.value) && relations.some((r) => r.relationEntity === i.value),
            }))}
            size={'large'}
          />
        </Form.Item>
      );
    case 'LEAD':
      return (
        <Form.Item
          label={`Entity*`}
          name={mode === 'add' ? 'relationEntity' : 'editRelationEntity'}
          rules={[
            { required: true, message: ValidationErrors.required('Entity value') },
            {
              validator: (_, value) => {
                if (
                  value &&
                  relations.some(
                    (r) =>
                      r.relationType === 'LEAD' &&
                      r.relationEntity?.trim() === value?.trim() &&
                      value?.trim() !== entityId
                  )
                ) {
                  return Promise.reject(new Error('This Lead ID is already added.'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input size={'large'} placeholder={`Enter Lead ID`} />
        </Form.Item>
      );
    case 'DEAL':
      return (
        <Form.Item
          label={`Entity*`}
          name={mode === 'add' ? 'relationEntity' : 'editRelationEntity'}
          rules={[
            { required: true, message: ValidationErrors.required('Entity value') },
            {
              validator: (_, value) => {
                if (
                  value &&
                  relations.some(
                    (r) =>
                      r.relationType === 'DEAL' &&
                      r.relationEntity?.trim() === value?.trim() &&
                      value?.trim() !== entityId
                  )
                ) {
                  return Promise.reject(new Error('This Deal ID is already added.'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input size={'large'} placeholder={`Enter Deal ID`} />
        </Form.Item>
      );
    case 'PURCHASE_REQUEST':
      return (
        <Form.Item
          label={`Entity*`}
          name={mode === 'add' ? 'relationEntity' : 'editRelationEntity'}
          rules={[
            { required: true, message: ValidationErrors.required('Entity value') },
            {
              validator: (_, value) => {
                if (
                  value &&
                  relations.some(
                    (r) =>
                      (r.relationType === 'PURCHASE_REQUEST' || r.relationType === 'DEAL') &&
                      r.relationEntity?.trim() === value?.trim() &&
                      value?.trim() !== entityId
                  )
                ) {
                  return Promise.reject(new Error('This Purchase Request ID is already added.'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input size={'large'} placeholder={`Enter Purchase Request ID`} />
        </Form.Item>
      );
    case 'PURCHASE_ORDER':
      return (
        <Form.Item
          label={`Entity*`}
          name={mode === 'add' ? 'relationEntity' : 'editRelationEntity'}
          rules={[
            { required: true, message: ValidationErrors.required('Entity value') },
            {
              validator: (_, value) => {
                if (
                  value &&
                  relations.some(
                    (r) =>
                      r.relationType === 'PURCHASE_ORDER' &&
                      r.relationEntity?.trim() === value?.trim() &&
                      value?.trim() !== entityId
                  )
                ) {
                  return Promise.reject(new Error('This Purchase Order ID is already added.'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input size={'large'} placeholder={`Enter Purchase Order ID`} />
        </Form.Item>
      );
    default:
      return null;
  }
};
